<template>
  <article>
    <div class="[ flex flex-col flex-1 text-black h-screen ]">
      <div :class="{
        'bg-highlight-green': isTrainingCall,
        'bg-gray-pale': !isTrainingCall,
      }" class="[ flex items-center px-5 py-4 sticky top-0 z-10 ]">
        <div class="flex flex-row justify-between w-full grow items-center">
          <router-link to="/scorecards" class="[ block text-center  ]">
            <Logo class="[ w-11 h-11 ]" />
          </router-link>
          <div data-nav-action class="[ flex-1 ]"></div>

          <div class="flex flex-col gap-4 justify-center">
            <!-- <div class="[ border-b pb-4 flex justify-center empty:hidden ]">
                  <AgentStatus v-if="!!callStreamProviderRef" @set-status="callStreamProviderRef.setAgentStatus" />
                </div> -->
            <CurrentUser size="xlarge" @click="showUserPopover" class="[ cursor-pointer ]" />

            <Popover ref="userPopover">
              <div class="[ flex flex-col gap-3 p-2 ]">
                <div>
                  <div class="[ font-medium ]">{{ fullName }}</div>
                  <div class="[ text-sm text-gray-dark ]">
                    {{ selectedTenantName }}
                  </div>
                </div>

                <div class="[ flex justify-between items-center ]">
                  <label class="[ text-sm ]" for="demo_switch">New Audio Player:</label>
                  <ToggleSwitch id="audio_player_switch" v-model="newPlayerEnabled" />
                </div>

                <div v-if="isSuperAdminUser">
                  <div class="[ flex justify-between items-center ]">
                    <label class="[ text-sm ]" for="role_switch">Viewing as:</label>
                    <Select id="role_switch" v-model="userRole" :options="roleOptions"
                      @value-change="setUserRoleOverride" />
                  </div>
                  <div class="[ flex justify-between items-center ]">
                    <label class="[ text-sm ]" for="demo_switch">Demo mode:</label>
                    <ToggleSwitch id="demo_switch" v-model="isDemoModeEnabled" />
                  </div>
                </div>
                <div class="[ border-t pt-3 ]" v-if="hasMultipleTenants">
                  <router-link to="/select" class="[ text-sm underline text-primary flex items-center ]">
                    <span>Switch tenant</span>
                    <PhCaretRight />
                  </router-link>
                </div>
                <router-link to="/auth/logout" class="[ text-sm underline text-primary flex items-center ]">
                  <span>Log out</span>
                  <PhCaretRight />
                </router-link>
              </div>
            </Popover>
          </div>

        </div>
      </div>

      <div class="[ flex flex-col flex-1 overflow-auto ]">
        <CallStreamProvider ref="callStreamProviderRef" />
        <div class="[ flex flex-row bg-gray-pale empty:hidden py-4 px-8 ]" data-header-action></div>
        <RouterView class="[ min-h-full w-full ]" :class="{
          'py-4 px-8': shouldApplyPadding
        }" />
      </div>
    </div>
  </article>

  <ProfileDrawer v-if="userProfile" v-model="showUserFlyout" :user="userProfile"
    @update:model-value="(v) => (showUserFlyout = v)" />
</template>

<script setup lang="ts">
import { Select, ToggleSwitch } from "primevue";
import { UserRole } from "@/services/api/sdk";
import { Popover } from "primevue";

import Logo from "@/assets/Logo.svg";
import CurrentUser from "@/components/auth/CurrentUser.vue";

import { useClientConfig } from "@/store/client-config.ts";
import { useAuthStore } from "@/store/auth.ts";

import { PhCaretRight } from "@phosphor-icons/vue";
import { useRouter } from "vue-router";
import { computed, ref } from "vue";
import { storeToRefs } from "pinia";
import CallStreamProvider from "@/components/contact/realtime/providers/CallStreamProvider.vue";

import ProfileDrawer from "@/components/agents/agent/ProfileDrawer.vue";
import { useUserStore } from "@/store/admin/user.ts";
import { useLiveCallStore } from "@/store/contact/live-call";

definePage({
  meta: {
    public: false,
    title: '',
  },
  redirect: "/scorecards",
});

const router = useRouter();
const { currentRoute } = router;
const { fullName, initialRole, roleOverride, isDemoModeEnabled, newPlayerEnabled } = storeToRefs(useAuthStore());
const { selectedTenantName, tenants } = storeToRefs(useClientConfig());
const { showUserFlyout, userProfile } = storeToRefs(useUserStore());

const { activeCall } = storeToRefs(useLiveCallStore());

const isTrainingCall = computed(() => activeCall.value?.customerPhoneNumber === '+15019994141');

const shouldApplyPadding = computed(() => !currentRoute.value.meta.noPadding);

const userRole = ref<UserRole | null>(roleOverride.value || initialRole.value);
const roleOptions = ref<UserRole[]>(Object.values(UserRole));

const isSuperAdminUser = computed<boolean>(() => {
  const realUserRole = initialRole.value || userRole.value;
  return realUserRole === UserRole.JackBurtonAdmin;
});
const hasMultipleTenants = computed<boolean>(
  () => Object.keys(tenants.value).length > 1,
);
const userPopover = ref();

function showUserPopover(e: Event) {
  userPopover.value.toggle(e);
}

function setUserRoleOverride(v: UserRole) {
  roleOverride.value = v;
  window.location.reload();
}
</script>
